import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Toast {
  id: number;
  type: 'success' | 'error' | 'warning' | 'info';
  title?: string;
  message: string;
  duration: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toasts = new BehaviorSubject<Toast[]>([]);
  public toasts$: Observable<Toast[]> = this.toasts.asObservable();
  private idCounter = 0;

  show(type: Toast['type'], message: string, title?: string, duration: number = 4000) {
    const id = ++this.idCounter;
    const toast: Toast = { id, type, message, title, duration };
    
    const currentToasts = this.toasts.value;
    this.toasts.next([...currentToasts, toast]);

    setTimeout(() => {
      this.remove(id);
    }, duration);
  }

  success(message: string, title?: string, duration?: number) {
    this.show('success', message, title, duration);
  }

  error(message: string, title?: string, duration?: number) {
    this.show('error', message, title, duration);
  }

  warning(message: string, title?: string, duration?: number) {
    this.show('warning', message, title, duration);
  }

  info(message: string, title?: string, duration?: number) {
    this.show('info', message, title, duration);
  }

  remove(id: number) {
    const currentToasts = this.toasts.value;
    this.toasts.next(currentToasts.filter(toast => toast.id !== id));
  }

  clear() {
    this.toasts.next([]);
  }
}
